import React from "react";
import ProgressSvg from "../../../assets/svgicons/progress-bar/progress_bar_3_1.svg";

const Progress_3_1 = (props) => {
  return <img src={ProgressSvg} alt="Progress 3-1" {...props} />;
};

export default Progress_3_1;
